var _path, _path2, _path3, _path4, _circle, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSadFaceFailure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.501 50H49.001V60H50.501V50Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.501 50H79.001V60H77.501V50Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0005 84C47.4749 84.1581 47.4748 84.1584 47.4748 84.1584L47.4766 84.1531L47.4842 84.1311C47.4913 84.1109 47.5024 84.0798 47.5176 84.0385C47.5481 83.9559 47.5953 83.8326 47.6603 83.6743C47.7903 83.3578 47.9915 82.902 48.2734 82.3535C48.8376 81.2556 49.7222 79.7917 51.0018 78.3293C53.5552 75.4111 57.6767 72.5 64.0005 72.5C70.3243 72.5 74.4458 75.4111 76.9992 78.3293C78.2788 79.7917 79.1634 81.2556 79.7277 82.3535C80.0095 82.902 80.2107 83.3578 80.3407 83.6743C80.4057 83.8326 80.4529 83.9559 80.4834 84.0385C80.4946 84.0689 80.5036 84.0937 80.5103 84.1127C80.5128 84.1196 80.515 84.1257 80.5168 84.1311L80.5245 84.1531L80.5263 84.1584C80.5263 84.1584 80.5262 84.1581 81.0005 84C81.4749 83.8419 81.4744 83.8404 81.4744 83.8404L81.4735 83.8379L81.4707 83.8295L81.4604 83.8001C81.4516 83.7748 81.4386 83.7386 81.4214 83.692C81.387 83.5988 81.3355 83.4643 81.2658 83.2944C81.1263 82.9547 80.9134 82.473 80.6171 81.8965C80.0251 80.7444 79.0972 79.2083 77.7518 77.6707C75.0552 74.5889 70.6767 71.5 64.0005 71.5C57.3243 71.5 52.9458 74.5889 50.2492 77.6707C48.9038 79.2083 47.9759 80.7444 47.3839 81.8965C47.0877 82.473 46.8748 82.9547 46.7353 83.2944C46.6655 83.4643 46.614 83.5988 46.5796 83.692C46.5624 83.7386 46.5494 83.7748 46.5406 83.8001L46.5304 83.8295L46.5275 83.8379L46.5264 83.8413C46.5264 83.8413 46.5262 83.8419 47.0005 84Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.001 64C114.001 91.6142 91.6152 114 64.001 114C36.3867 114 14.001 91.6142 14.001 64C14.001 36.3858 36.3867 14 64.001 14C91.6152 14 114.001 36.3858 114.001 64ZM113.001 64C113.001 91.062 91.0629 113 64.001 113C36.939 113 15.001 91.062 15.001 64C15.001 36.938 36.939 15 64.001 15C91.0629 15 113.001 36.938 113.001 64Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 97,
    r: 20,
    fill: "#FF248A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.75 87H96.25V103H97.75V87Z",
    fill: "#351648"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98 105H96V107H98V105Z",
    fill: "#351648"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFaceFailure);
export default __webpack_public_path__ + "static/media/sad-face-failure.993ae1ea.svg";
export { ForwardRef as ReactComponent };